import {
  URLS,
  PRODUCT_SUITES,
} from 'gatsby-theme-marketplace-base/src/constants'

export const productSuites = PRODUCT_SUITES.filter(
  (item) => item.label !== URLS.HELPDESK.LABEL
)

export default (props) => null
